export default __webpack_public_path__ + "static/media/privacy_policy.7eacad06.pdf";